import React from 'react'
import propTypes from 'prop-types'
import './newItem.scss'

const NewItem = (props) => {
  const { label, icon, className, onClick } = props
  return (
    <div className={`new-item ${className}`} onClick={onClick}>
      {icon ? icon : null}
      <div className="label">{label}</div>
    </div>)
}

NewItem.propTypes = {
  label: propTypes.string.isRequired,
  className: propTypes.string.isRequired,
  icon: propTypes.element,
  onClick: propTypes.func.isRequired,
}

export default NewItem
